import React from "react";
import { Route, Routes } from "react-router-dom";
import Home from "./Home";
import Assessement from "./Assessement";

const RiskAssesment = () => {
  return (
    <Routes>
      <Route index element={<Home />} />
      <Route path="*" element={<Assessement />} />
    </Routes>
  );
};

export default RiskAssesment;
